"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNilOrEmpty = void 0;
/**
 * Check if a string is nil or empty.
 *
 * @param val a value that may be a string
 * @returns true if the string is nil or empty
 */
function isNilOrEmpty(val) {
    return val == null || val === '';
}
exports.isNilOrEmpty = isNilOrEmpty;
//# sourceMappingURL=stringExt.js.map